import {getCurrentDomainName} from '../utils/http/domain'

export enum SidebarPermission {
  HOME = 'Home',
  MARKETING = 'Marketing',
  SALES = 'Sales',
  HUMAN_RESOURCE = 'Human Resource',
  FINANCE = 'Finance',
  REAL_ESTATE = 'Real Estate',
  CHAT = 'Chat',
  IMAGES = 'Images',
  RECENT_ACTIVITY = 'Recent Activity',
  SETTINGS = 'Settings',
}

export enum Domain {
  KLEVERE_AI = 'app.klevere.ai',
  LOCAL_IP = '127.0.0.1',
  LOCAL_IP_ON_NETWORK = '10.0.0.101',
  PRODUCTION_IP = '35.156.184.218',
  LOCAL_HOST = 'localhost',
}

const domainPermissionsMap: Record<Domain, SidebarPermission[]> = {
  [Domain.KLEVERE_AI]: [
    SidebarPermission.HOME,
    SidebarPermission.MARKETING,
    SidebarPermission.SALES,
    SidebarPermission.HUMAN_RESOURCE,
    SidebarPermission.IMAGES,
    SidebarPermission.RECENT_ACTIVITY,
    SidebarPermission.SETTINGS,
    SidebarPermission.CHAT,
    SidebarPermission.FINANCE,
    SidebarPermission.REAL_ESTATE,
  ],
  [Domain.LOCAL_IP]: [
    SidebarPermission.HOME,
    SidebarPermission.MARKETING,
    SidebarPermission.SALES,
    SidebarPermission.HUMAN_RESOURCE,
    SidebarPermission.IMAGES,
    SidebarPermission.RECENT_ACTIVITY,
    SidebarPermission.SETTINGS,
    SidebarPermission.CHAT,
    SidebarPermission.FINANCE,
    SidebarPermission.REAL_ESTATE,
  ],
  [Domain.LOCAL_IP_ON_NETWORK]: [
    SidebarPermission.HOME,
    SidebarPermission.MARKETING,
    SidebarPermission.SALES,
    SidebarPermission.HUMAN_RESOURCE,
    SidebarPermission.IMAGES,
    SidebarPermission.RECENT_ACTIVITY,
    SidebarPermission.SETTINGS,
    SidebarPermission.CHAT,
    SidebarPermission.FINANCE,
    SidebarPermission.REAL_ESTATE,
  ],
  [Domain.PRODUCTION_IP]: [
    SidebarPermission.HOME,
    SidebarPermission.MARKETING,
    SidebarPermission.RECENT_ACTIVITY,
    SidebarPermission.IMAGES,
  ],
  [Domain.LOCAL_HOST]: [
    SidebarPermission.HOME,
    SidebarPermission.MARKETING,
    SidebarPermission.RECENT_ACTIVITY,
    SidebarPermission.IMAGES,
  ],
}

export const workflowsPermissionsMap: Record<string, string[]> = {
  [Domain.PRODUCTION_IP]: [
    '550e8400-e29b-41d4-a716-446655440001',
    '2c39b876-5a41-4d6f-9b7a-7c0b5f6d3a9f',
    '1b671a64-40d5-491e-99b0-da01ff1f3342',
    '123e4567-e89b-12d3-a456-426614174001',
    '7c9e6679-7425-40de-944b-e07fc1f90ae7',
    '9c6d8c5d-6d7d-4e3a-9e1d-5b3f1c2a0b4f',
    '5e228958-4d45-4f8b-8d32-7a3a4f1b5c9e',
    '6ba7b810-9dad-11d1-80b4-00c04fd430c9',
  ],
  [Domain.LOCAL_HOST]: [
    '550e8400-e29b-41d4-a716-446655440001',
    '1b671a64-40d5-491e-99b0-da01ff1f3342',
    '123e4567-e89b-12d3-a456-426614174001',
    '7c9e6679-7425-40de-944b-e07fc1f90ae7',
    '9c6d8c5d-6d7d-4e3a-9e1d-5b3f1c2a0b4f',
    '5e228958-4d45-4f8b-8d32-7a3a4f1b5c9e',
    '6ba7b810-9dad-11d1-80b4-00c04fd430c9',
    '2c39b876-5a41-4d6f-9b7a-7c0b5f6d3a9f',
  ],
}

export const getWhiteLabelWorkflows = () => workflowsPermissionsMap[getCurrentDomainName()]

export const hasPermission = (domain: string, permission: SidebarPermission): boolean => {
  const permittedPermissions = domainPermissionsMap[domain as Domain] || []
  return permittedPermissions.includes(permission)
}

export const isRunningOnKlevereDomain = () => {
  return getCurrentDomainName() === Domain.KLEVERE_AI || getCurrentDomainName() === Domain.LOCAL_IP
}

export const isRunningOnProductionDomain = () => {
  return getCurrentDomainName() === Domain.PRODUCTION_IP
}
